import { render, staticRenderFns } from "./GridVue.vue?vue&type=template&id=21939684&scoped=true"
import script from "./GridVue.vue?vue&type=script&lang=js"
export * from "./GridVue.vue?vue&type=script&lang=js"
import style0 from "./GridVue.vue?vue&type=style&index=0&id=21939684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21939684",
  null
  
)

export default component.exports